import { Controller } from "@hotwired/stimulus"

// As prévias do assistente de publicação — Google, cartão social, push, chapéu e checklist — a
// partir do que está nos campos agora, com os mesmos fallbacks da página pública (PostSeoHelper) e
// do push (PostPushNotification).
//
// `data-source` é uma lista "a|b|c": ids de campos do form, ou "headline" (a manchete, que não é
// editada aqui) e "kicker" (lugares e assuntos como no PostsHelper#post_kicker). Vale o primeiro
// que tiver valor. Num `check`, o estado é "ok" quando o primeiro tem valor, "fallback" quando só um
// dos seguintes tem, e "missing"/"empty" quando nenhum (obrigatório ou não).
export default class extends Controller {
  static targets = ["text", "check"]
  static values = { headline: String }

  connect() {
    this.refresh()
  }

  refresh() {
    this.textTargets.forEach((element) => {
      const value = this.#sources(element).map((source) => this.#read(source)).find(Boolean) || ""
      const limit = Number(element.dataset.limit || 0)

      element.textContent = value ? (limit ? truncate(value, limit) : value) : (element.dataset.empty || "")
      element.classList.toggle("is-empty", !value)
    })

    this.checkTargets.forEach((element) => {
      const [own, ...fallbacks] = this.#sources(element).map((source) => this.#read(source))

      if (own) element.dataset.state = "ok"
      else if (fallbacks.some(Boolean)) element.dataset.state = "fallback"
      else element.dataset.state = element.dataset.required === "true" ? "missing" : "empty"
    })
  }

  #sources(element) {
    return (element.dataset.source || "").split("|").filter(Boolean)
  }

  #read(source) {
    if (source === "headline") return this.headlineValue.trim()
    if (source === "kicker") return this.#kicker()

    const field = this.element.querySelector(`#${CSS.escape(source)}`)
    if (!field) return ""
    if (field.tagName === "SELECT") return this.#selectedLabels(field).join(" | ")

    return field.value.trim()
  }

  #selectedLabels(select) {
    return Array.from(select.selectedOptions)
      .filter((option) => option.value !== "")
      .map((option) => option.textContent.trim())
  }

  #kicker() {
    const category = this.#read("post_category_id").toLocaleLowerCase("pt-BR")
    const terms = ["post_place_list", "post_tag_list"].flatMap((id) => {
      const select = this.element.querySelector(`#${id}`)
      return select ? this.#selectedLabels(select) : []
    })
    const seen = new Set()

    return terms
      .filter((term) => {
        const key = term.toLocaleLowerCase("pt-BR")
        if (key === category || seen.has(key)) return false
        seen.add(key)
        return true
      })
      .join(" | ")
  }
}

// O `truncate(limit, separator: " ")` do Rails: corta no último espaço antes do limite e põe "...".
function truncate(text, limit) {
  if (text.length <= limit) return text

  const room = limit - 3
  const space = text.lastIndexOf(" ", room)
  return `${text.slice(0, space > 0 ? space : room)}...`
}
